interface PaginatedResultTypeList<T> {
    count: number;
    next?: string;
    previous?: string;
    results: Array<T>;
    numPages?: number;
}

interface WithPagination {
    pageSize?: number;
    page?: number;
}

export const fetchAllWithPagination = async <
    ParametersType extends WithPagination,
    ReturnType,
>(
    listFn: (
        requestParameters: ParametersType,
    ) => Promise<PaginatedResultTypeList<ReturnType>>,
    requestParameters: ParametersType,
): Promise<ReturnType[]> => {
    const pageSize = requestParameters.pageSize || 200;

    // Make sure to include page size back into the request parameters
    // in case it wasn't there and we set it to 200 above
    const requestParameters_ = {
        ...requestParameters,
        pageSize,
    };

    const response = await listFn(requestParameters_);

    if (response.count <= pageSize) {
        return response.results;
    }

    const remainingPages = Math.floor(response.count / pageSize);
    const allData: ReturnType[] = [...response.results];

    for (let idx = 0; idx < remainingPages; idx++) {
        const page = idx + 2;
        const responsePage = await listFn({
            ...requestParameters_,
            page,
        });
        allData.push(...responsePage.results);
    }

    return allData;
};
